import { jsx as a } from "@emotion/react/jsx-runtime";
import r from "prop-types";
import { BREAKPOINTS as i } from "../../constants.mjs";
import { GRID_PADDING as o } from "./gridConstants.mjs";
import { Grid as l } from "./Grid.mjs";
import { css as t } from "@emotion/react";
import f from "./Col.mjs";
import g from "./Bleed.mjs";
const d = {
  fullPage: t`
        max-width: 1440px;
        margin: auto;
        width: 100%;
        box-sizing: border-box;
    `,
  padding: t`
        padding-left: ${o.SMALL};
        padding-right: ${o.SMALL};

        @media (min-width: ${i.MEDIUM}rem) {
            padding-left: ${o.MEDIUM};
            padding-right: ${o.MEDIUM};
        }

        @media (min-width: ${i.LARGE}rem) {
            padding-left: ${o.LARGE};
            padding-right: ${o.LARGE};
        }
    `
}, s = "div", e = ({
  children: m,
  component: n,
  ...p
}) => /* @__PURE__ */ a(l, { component: n || s, ...p, css: [d.fullPage, d.padding], children: m });
e.propTypes = {
  children: r.oneOfType([r.node, r.arrayOf(r.node)]),
  /** Enable row gutter */
  hasRowGutter: r.bool
};
e.Col = f;
e.Bleed = g;
export {
  g as Bleed,
  f as Col,
  e as FullPageGrid,
  e as default
};
